<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!salesInvoice">
      <span class="loader"></span>
    </span>
    <div v-if="salesInvoice" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        :value="currentTab"
        @onTabChanged="tabChanged"
      >
        <tab-pane title="global" id="1" :active="false">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <sales-invoice-view-global :salesInvoice="salesInvoice" />
        </tab-pane>

        <tab-pane title="details" id="2" :active="false">
          <span slot="title">
            <i class="ni ni-bullet-list-67"></i>
            {{ $t("COMMON.DETAILS") }}
          </span>
          <sales-invoice-view-details
            :salesInvoice="salesInvoice"
            @salesInvoiceItemsUpdated="get"
          />
        </tab-pane>

        <tab-pane
          title="payments"
          id="3"
          :active="false"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_SALES_PAYMENTS)"
        >
          <span slot="title">
            <i class="ni ni-money-coins"></i>
            {{ $t("COMMON.PAYMENTS") }}
          </span>
          <sales-invoice-view-payments :salesInvoice="salesInvoice" />
        </tab-pane>

        <tab-pane
          title="files"
          id="998"
          v-if="
            $currentUserCan($permissions.PERM_VIEW_ANY_FILES) &&
            salesInvoice.organization
          "
        >
          <span slot="title">
            <i class="ni ni-folder-17"></i>
            {{ $t("COMMON.FILES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <list-file-component :object="salesInvoice" />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <sales-invoice-view-logs :salesInvoice="salesInvoice" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import {
  INVOICE_STATUS_CANCELED,
  INVOICE_STATUS_DRAFT,
  INVOICE_STATUS_VALIDATED,
} from "@/constants/invoices";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import SalesInvoiceViewGlobal from "../partials/SalesInvoiceViewGlobal.vue";
import SalesInvoiceViewDetails from "../partials/SalesInvoiceViewDetails.vue";
import SalesInvoiceViewLogs from "../partials/SalesInvoiceViewLogs.vue";
import SalesInvoiceViewPayments from "../partials/SalesInvoiceViewPayments.vue";
import hasTabs from "@/mixins/has-tabs";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    SalesInvoiceViewGlobal,
    SalesInvoiceViewDetails,
    SalesInvoiceViewLogs,
    ListFileComponent,
    SalesInvoiceViewPayments,
  },

  mixins: [requestErrorMixin, hasTabs],

  props: {
    salesInvoiceId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      salesInvoice: null,
      INVOICE_STATUS_DRAFT: INVOICE_STATUS_DRAFT,
      INVOICE_STATUS_CANCELED: INVOICE_STATUS_CANCELED,
      INVOICE_STATUS_VALIDATED: INVOICE_STATUS_VALIDATED,
    };
  },

  computed: {
    canCancelSalesInvoice() {
      if (
        this.salesInvoice.status === INVOICE_STATUS_CANCELED ||
        this.salesInvoice.status === INVOICE_STATUS_DRAFT
      ) {
        return false;
      }
      if (this.salesInvoice.status === INVOICE_STATUS_VALIDATED) {
        return true;
      }
      return false;
    },
  },

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("salesInvoices/get", this.salesInvoiceId);
        this.salesInvoice = this.$store.getters["salesInvoices/salesInvoice"];
        this.$emit("salesInvoiceLoaded", this.salesInvoice);
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
